// ============================================================
// หน้า CreateRole — เพิ่มบทบาทผู้ใช้
// ------------------------------------------------------------
// ฟอร์มและตารางติ๊กสิทธิ์อยู่ที่ components/custom/ui/RoleForm.js
// ตรรกะแปลงข้อมูลอยู่ที่ components/custom/role.js (ใช้ร่วมกับหน้าแก้ไขบทบาท)
// ============================================================

import React, { Component } from "react";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar";
import { loading, tokens, success_url, POST, validate, RoleForm, emptyRoleDetail, toApiRoleDetail } from "../../shared/index.js";

export default class CreateRole extends Component {
  state = { role_name: "", role_description: "", role_detail: emptyRoleDetail() };

  componentDidMount() {
    loading(false);
  }

  Create = async () => {
    if (validate(this.state, ["role_name"])) return;
    loading(true);

    const { role_name, role_description, role_detail } = this.state;
    const result = await POST(tokens, "v1/TH/role-manage/create", { role_name, role_description, role_detail: toApiRoleDetail(role_detail) });
    if (result?.status) success_url("/role");

    loading(false);
  };

  render() {
    return (
      <div className="full bg-contain fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลผู้ใช้" page3="บทบาทผู้ใช้" />
        <RoleForm
          title="เพิ่มบทบาทผู้ใช้"
          submitLabel="เพิ่ม"
          role_name={this.state.role_name}
          role_description={this.state.role_description}
          role_detail={this.state.role_detail}
          onChange={(patch) => this.setState(patch)}
          onSubmit={this.Create}
        />
      </div>
    );
  }
}
